import BaseDialog from './../../../zzl-vue-component/BaseDialog'
import PageList from './../../api/PageList'

const MAX_RESULTS = 7
const SEARCH_DELAY = 150

export default {
	name: 'PageSelectDialog',
	props: {
		value: {
			type: [Number, null]
		}
	},
	data() {
		return {
			selectedPage: this.value ? {
				id: this.value,
				title: '読み込み中...',
				description: '',
				pub_date: '',
				exp_date: '',
			} : null,
			query: '',
			emptyQuery: true,
			queryTimer: null,
			items: [],
			matchedItems: [],
		}
	},
	components: {
		BaseDialog,
	},
	template: `
		<BaseDialog class="page-select"
			title="ページを選択"
		>
			<input type="text" class="form-control" v-model="query" placeholder="名前から検索"
				ref="firstInput"
			/>
			<span v-if="emptyQuery" class="label label-default">最近更新したページ</span>
			<div class="list-group page-select-list-group">
				<div class="list-group-item page-select-search-result-item disabled"
					v-if="matchedItems.length === 0"
				>
					ページがありません
				</div>
				<div class="list-group-item page-select-search-result-item"
					v-for="item in matchedItems" :key="item.id"
					@click="select(item)"
					tabindex="0"
				>
					<div>{{item.title}}</div>
					<span class="small text-muted">{{item.url}}</span>
				</div>
			</div>

			<template v-slot:buttons>
				<button type="button" class="bs-ed-btn bs-ed-btn-default"
					@click="$emit('cancel')"
				>
					キャンセル
				</button>
			</template>
		</BaseDialog>
	`,
	mounted() {
		this.$refs.firstInput.focus()

		PageList.get().then(items => {
			this.items = items
			this.search()
			if (this.value) {
				items.filter(item => item.id === this.value)
				.some(item => this.selectedPage = item)
			}
		})
	},
	beforeDestroy() {
		clearTimeout(this.queryTimer)
	},
	methods: {
		search() {
			const { query } = this

			if (query.trim() === '') {
				this.emptyQuery = true
				this.matchedItems = this.items.slice(0, MAX_RESULTS)
			} else {
				this.emptyQuery = false
				this.matchedItems = this.items
					.filter(item => item.title.indexOf(query) >= 0 || item.url.indexOf(query) >= 0)
					.slice(0, MAX_RESULTS)
			}
		},
		select(item) {
			this.selectedPage = item
			this.$emit('input', item.id)
		},
		reset() {
			this.selectedPage = null
			this.$nextTick(() => this.$refs.query.focus())
		}
	},
	watch: {
		query() {
			clearTimeout(this.queryTimer)
			this.queryTimer = setTimeout(() => this.search(), SEARCH_DELAY)
		}
	}
}
